import React from 'react';

import './notFound.css';



const NotFound = () => {
  return (
    <div className="not-found-container">
        <img src="/images/notFound.gif"/>
        <h1>404 Not Found</h1>
        <p>The page you are looking for is invalid</p>
    </div>
  )
}

export default NotFound